export default {
  name: 'transaction_amount',
  component_path: 'modules/procedures/blocks/transaction/BlockTransactionFormAmount',
  static_mandatory: ['numeric', 'minAmount:100']
}